import React, { useState, useRef, useEffect } from 'react';
import './DatePickers.css';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import clock from "../../assets/images/svg/clock.svg";
import resetIcon from "../../assets/images/svg/close.svg"; 
import frLocale from 'date-fns/locale/fr';
import enLocale from 'date-fns/locale/en-US';
import { format } from 'date-fns';


const DatePickers = ({ inputType, onDateChange, onReset, translations , language}) => {

  const [showCalendar, setShowCalendar] = useState(false);
  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection',
    },
  ]);

  const [inputValue, setInputValue] = useState('');
  const [showResetButton, setShowResetButton] = useState(false);

  const calendarRef = useRef(null);

  const handleSelect = (ranges) => {
    setDateRange([ranges.selection]);
    setShowCalendar(false);

    if (onDateChange) {
      const selectedDate = ranges.selection;
      onDateChange(selectedDate);
    }
  };

  const handleInputClick = () => {
    setShowCalendar(true);
  };

  const handleCalendarBlur = (event) => {
    if (calendarRef.current && calendarRef.current.contains(event.relatedTarget)) {
      return;
    }

    if (!dateRange[0].startDate && !dateRange[0].endDate) {
      setShowResetButton(false);
    }
    
    setShowCalendar(false);
  };

  const handleResetClick = () => {
    if (onReset) {
      onReset();
    }
    setDateRange([
      {
        startDate: null,
        endDate: null,
        key: 'selection',
      },
    ]);
    setInputValue('');
    setShowCalendar(false);
    setShowResetButton(false);
    if (onDateChange) {
      onDateChange(null);
    }
  };



  const formatValue = (startDate, endDate) => {
    const selectedLocale = language === 'fr' ? frLocale : enLocale; // Determine locale based on the selected language
    if (inputType === 'datetime') {
      return `${format(startDate, 'EEE MMM dd yyyy', { locale: selectedLocale })} - ${format(endDate, 'EEE MMM dd yyyy', { locale: selectedLocale })}`;
    } else {
      return format(startDate, 'EEE MMM dd yyyy', { locale: selectedLocale });
    }
  };

  
  // useEffect(() => {
  //   const { startDate, endDate } = dateRange[0];
  //   if (startDate && endDate) {
  //     setInputValue(formatValue(startDate, endDate));
  //   } else if (startDate) {
  //     setInputValue(formatValue(startDate, startDate));
  //   } else {
  //     setInputValue('Start - End Date: All-time');
  //   }

  //   setShowResetButton(!!startDate); // Set showResetButton based on the presence of a startDate
  // }, [dateRange, inputType]);

  useEffect(() => {
    const { startDate, endDate } = dateRange[0];
    
    if (startDate && endDate) {
      setInputValue(formatValue(startDate, endDate));
    } else if (startDate) {
      setInputValue(formatValue(startDate, startDate));
    } else {
      setInputValue(translations?.message?.dateHint ? translations.message.dateHint : "Start - End Date: All-time");
    }
  
    setShowResetButton(!!startDate || showCalendar); // Set showResetButton based on the presence of a startDate or if the calendar is shown
  }, [dateRange, inputType, showCalendar]);

  const datepickerStyle = {
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'calc(100% - 10px)',
    backgroundColor: '#fff',
  };

  

  if (showCalendar) {
    datepickerStyle.backgroundImage = 'none';
  } else if (inputType === 'datetime' && dateRange[0].startDate && dateRange[0].endDate) {
    datepickerStyle.backgroundImage = 'none';
  } else if (inputType !== 'datetime') {
    datepickerStyle.backgroundImage = 'none';
  } else {
    datepickerStyle.backgroundImage = `url(${clock})`;
  }

  const datepickerContainerClasses = showCalendar && inputType !== 'datetime' ? 'hide-range-styles' : '';

  return (
    <div className={`datepicker-container ${datepickerContainerClasses}`}>
      <div className="date-picker-wrapper">
        <input
          className="date-picker"
          type="text"
          value={inputValue}
          readOnly
          onClick={handleInputClick}
          style={datepickerStyle}
          locale="fr" 
          lang="fr"
        />
        {showResetButton && (
          <button className="reset-button" onClick={handleResetClick}>
            <img src={resetIcon} alt="Reset" />
          </button>
        )}
      </div>
      {showCalendar && (
        <div ref={calendarRef} >
          <DateRangePicker
            ranges={dateRange}
            onChange={handleSelect}
            showSelectionPreview={true}
            moveRangeOnFirstSelection={false}
            editableDateInputs={true}
            locale={ language=="fr" ?frLocale: enLocale}
          />
        </div>
      )}
    </div>
  );
};

export default DatePickers;
